import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getTransportsAction } from '../../../services/request';
import { TransportList } from './transport/TransportList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const TransportRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getTransportsAction(search, 'GET'));
  const optionsRequest = useQuery(getTransportsAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [transports, setTransports] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allResorts, setAllResorts] = React.useState([]);
  const [allSeasons, setAllSeasons] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setTransports(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllResorts(optionsRequest.payload.actions.GET.resort.choices);
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setTransports(
        _.map(transports, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setTransports(_.filter(transports, obj => obj.id !== obj2.id));
    } else {
      setTransports([obj2, ...transports]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <TransportList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        transports={transports}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allResorts={allResorts}
        allSeasons={allSeasons} />
    </>
  );
};
